import {useMutation} from "@tanstack/react-query";
import {deleteOfferTemplateMutationOptions} from "./delete-offer-template.mutation-options";

export function useDeleteOfferTemplate() {
  return useMutation(deleteOfferTemplateMutationOptions());
}
